import React, {useContext, useEffect, useState} from 'react';
import {Tree} from "primereact/tree";
import {FaCheck, FaMapMarker, FaTrash} from "react-icons/fa";
import Button from "../../../../../components/button/button.jsx";
import {PointLayerContext} from "../point-layer-context.jsx";

let canRemoveMarker = true

const PanelKmz = ({kmzData, createMarker, iconSelected, removeMarker, showKmzPanel, setShowKmzPanel, coreLib, map}) => {
    const {setIsLoading, setPoints} = useContext(PointLayerContext)
    const [kmzSelected, setKmzSelected] = useState([]);
    const [selectionNodeKeys, setSelectionNodeKeys] = useState([]);
    const [preListPoints, setPreListPoints] = useState([])

    useEffect(() => {
        if (!showKmzPanel) {
            if (canRemoveMarker) {
                for (const kmz of kmzSelected) removeMarker(kmz.key)
            }
            setKmzSelected([])
            setSelectionNodeKeys([])
            setPreListPoints([])

            removeMarker = true
        }
    }, [showKmzPanel]);

    useEffect(() => {
        if (!coreLib) return

        const bounds = new coreLib.LatLngBounds();
        const preList = []
        for (const kmz of kmzSelected) {
            removeMarker(kmz.key)
            const point = createMarker({
                id: kmz.key,
                position: kmz.Coordinates,
                icon: iconSelected.marker,
                editing: false,
                draggable: false,
                name: kmz.label
            })

            bounds.extend(new coreLib.LatLng(kmz.Coordinates.lat, kmz.Coordinates.lng));
            preList.push(point)
        }

        if (preList.length) map.fitBounds(bounds);

        setPreListPoints(preList);
    }, [kmzSelected, coreLib]);

    const templateToTree = ({icon_custom, label, id, children}) => {
        if (children && children.length > 0) {
            return (
                <div className={"p-tree-node flex items-center gap-2 p-1"}>
                    <span className="p-tree-node-label">{label}</span>
                </div>
            );
        }

        return (
            <div key={id} className="p-tree-node flex items-center gap-2 p-1">
                { icon_custom && <FaMapMarker /> }
                <span className="p-tree-node-label">{label}</span>
            </div>
        );
    }

    const onSelectionChange = ({value}) => {
        setIsLoading(true)
        const keys = Object.keys(value);
        const kmz = getKmzSelect(keys, kmzData);

        const kmzRemoved = kmzSelected.filter(a => !kmz.some(b => b.key === a.key));
        if (kmzRemoved.length) {
            for (const k of kmzRemoved) removeMarker(k.key)
            const keysToRemove = new Set(kmzRemoved.map(item => item.key));
            setPreListPoints(prev =>
                prev.filter(item => !keysToRemove.has(item.id))
            );
        }

        setKmzSelected(kmz);
        setSelectionNodeKeys(value);
        setIsLoading(false)
    }

    const getKmzSelect = (keys, data) => {
        const result = [];

        keys.forEach(key => {
            const find = data.find(item => item.key === key);

            if (find) {
                if (find.children) result.push(...getKmzSelect(keys, find.children));
                else if (find.type) result.push(find);
            }

        });

        return result;
    }

    const add = () => {
        canRemoveMarker = false
        setPoints(prevState => [...prevState, ...preListPoints])
        setShowKmzPanel(false)
    }

    return (
        <>
            <div className={"mb-3"}>
                <p className={"text-xs font-bold"}>Importação de arquivo</p>
            </div>
            <div className={"mb-3 h-[calc(100vh-150px)] overflow-auto tree-kmz"}>
                {
                    kmzData.length > 0 &&
                    <Tree value={kmzData}
                          className="custom-sub-itens"
                          selectionMode="checkbox"
                          nodeTemplate={templateToTree}
                          selectionKeys={selectionNodeKeys}
                          onSelectionChange={onSelectionChange}
                    />
                }
            </div>

            <div className={"flex justify-end gap-3"}>
                <Button target={"secondary"} onClick={() => setShowKmzPanel(false)}>
                    Cancelar
                </Button>
                <Button onClick={add}>
                    <FaCheck /> Confirmar
                </Button>
            </div>
        </>
    );
};

export default PanelKmz;